exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-watching{top:0!important;position:fixed!important}", ""]);

// exports
